export default __webpack_public_path__ + "static/media/master.e56de037.svg";